import React from "react";
import ReactDOM from "react-dom/client";
import "./style/index.css";
import App from "./App";

console.log("Before ReactDOM.render");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log("After ReactDOM.render");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
